import { render, staticRenderFns } from "./DemoSelector.vue?vue&type=template&id=25c6456e&scoped=true"
import script from "./DemoSelector.vue?vue&type=script&lang=js"
export * from "./DemoSelector.vue?vue&type=script&lang=js"
import style0 from "./DemoSelector.vue?vue&type=style&index=0&id=25c6456e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25c6456e",
  null
  
)

export default component.exports